import React from "react";

const SLOTS = [
    {
        id: "slot-1",
        label: "Pitcher Audit",
        title: "Pitcher Audit",
        image: "/shot-1.png",
        alt: "Tiltbox pitcher audit screen showing projections, sim range, and confidence for Joey Cantillo (CLE vs NYY).",
    },
    {
        id: "slot-2",
        label: "Build Parlay",
        title: "Build Parlay",
        image: "/shot-2.png",
        alt: "Tiltbox Build Parlay screen with sport filters and over/under safety scoring on strikeouts and hits allowed.",
    },
    {
        id: "slot-3",
        label: "Ticket Grade",
        title: "Ticket Grade",
        image: "/shot-3.png",
        alt: "Tiltbox ticket grade screen with a letter grade and modeled win probability for the parlay.",
    },
];

export default function Showcase() {
    return (
        <section
            id="showcase"
            data-testid="showcase-section"
            className="relative py-20 md:py-28"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex flex-col items-center text-center mb-14 md:mb-20">
                    <span
                        data-testid="showcase-eyebrow"
                        className="tb-overline mb-5"
                    >
                        Inside the Box
                    </span>
                    <h2
                        data-testid="showcase-title"
                        className="tb-h2 text-3xl md:text-4xl lg:text-5xl max-w-2xl"
                    >
                        A typical Tiltbox audit.
                    </h2>
                </div>

                <div
                    data-testid="showcase-grid"
                    className="flex flex-col md:flex-row gap-8 md:gap-10 justify-center items-stretch"
                >
                    {SLOTS.map((s, i) => (
                        <figure
                            key={s.id}
                            data-testid={`showcase-${s.id}`}
                            className="tb-placeholder tb-reveal w-full max-w-[320px] md:max-w-[300px] aspect-[4/5] flex flex-col p-0"
                            style={{ animationDelay: `${120 + i * 140}ms` }}
                            aria-label={s.alt}
                        >
                            <img
                                src={s.image}
                                alt={s.alt}
                                className="w-full h-full object-contain rounded-[28px] bg-[#050505]"
                                loading="lazy"
                            />
                        </figure>
                    ))}
                </div>

                <div
                    data-testid="showcase-labels"
                    className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 max-w-4xl mx-auto"
                >
                    {SLOTS.map((s) => (
                        <div
                            key={`${s.id}-label`}
                            className="text-center"
                        >
                            <p
                                className="font-display text-white text-base md:text-lg font-bold tracking-tight"
                                data-testid={`showcase-${s.id}-title`}
                            >
                                {s.title}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
